import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ISingInState {
  token: string;
}

const initialState: ISingInState = {
  token: ''
};

export const signIn = createSlice({
  name: 'singIn',
  initialState,
  reducers: {
    saveToken: (state, action: PayloadAction<ISingInState>) => {
      state.token = action.payload.token;
    }
  }
});

export const { saveToken } = signIn.actions;
export const signInReducer = signIn.reducer;
